import script from "./GroupSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./GroupSettings.vue?vue&type=script&setup=true&lang=js"

import "./GroupSettings.vue?vue&type=style&index=0&id=4da6e650&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4da6e650"]])

export default __exports__